import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { OrderSummaryButton } from '../../../common/OrderSummary';
import useCurrentAmountAndCreditBalance from '../../../../shared/utils/currentAmountAndCreditBalance/useCurrentAmountAndCreditBalance';
import pubSubInstance from '../../../../shared/utils/pubSub';
import { usePennyRounding } from '../../../../shared/utils/customizedHooks';

const OrderSummaryButtonContainer = () => {
  const {
    widgetNameSpace, showScrollToOrderSummaryBar,
  } = useSelector(state => state.propsData);
  const {
    entities: {
      orderInfo,
      orderInfo: { currencyCode },
    },
  } = useSelector(state => state.mainStateData);
  const {
    currentActivePaymentMethod,
    entities: {
      paymentMethods: {
        cashInfo: {
          pennyRounding,
        } = {},
      } = {},
    },
  } = useSelector(state => state.paymentMethods);

  const handleSubmit = useCallback(() => {
    pubSubInstance.dispatch(`${widgetNameSpace}-submit-order`);
  }, [ widgetNameSpace ]);
  const { yourPayment } = useCurrentAmountAndCreditBalance();

  const {
    grandTotal,
  } = usePennyRounding([ yourPayment, currentActivePaymentMethod, pennyRounding, currencyCode ]);

  const paymentAmount = useMemo(() => (grandTotal !== undefined ? grandTotal : yourPayment),
    [ grandTotal, yourPayment ]); // should cover grandTotal is 0 case

  return (
    <OrderSummaryButton {...orderInfo}
      widgetNameSpace={widgetNameSpace}
      paymentMethodType={currentActivePaymentMethod}
      onSubmit={handleSubmit}
      currentAmountDue={paymentAmount}
      showScrollToOrderSummaryBar={showScrollToOrderSummaryBar}
      className="cui-mg-t-60"/>
  );
};

export default memo(OrderSummaryButtonContainer);
